export default "__VITE_ASSET__CYWzh8G9__"